import React from "react";
import { cn } from "../../../../helper/cn";
import CheckBoxSqure from "../../../../components/commonComponents/checkbox/CheckBoxSqure";

const FilterComponent = ({
  isClearEnabled,
  selectedFilterType,
  loading,
  onFilterChange,
  clearType,
}) => {
  return (
    <div className="px-3.5 py-2.5 w-[13vw]">
      <div className="text-[var(--font-400)] flex-row align-center space-between w-100">
        <span>Filter</span>
        <div
          className={cn(
            "text-[#F96056]",
            isClearEnabled
              ? "cursor-pointer opacity-100"
              : "cursor-not-allowed opacity-50"
          )}
          onClick={() => {
            if (isClearEnabled) clearType();
          }}
        >
          Clear
        </div>
      </div>

      {selectedFilterType?.map((s) => (
        <div
          key={s?.id}
          className="w-full h-9 flex items-center gap-2.5 py-1 cursor-pointer new-body-text p-10 mt-10 hover:bg-[var(--channelButton)] b-radius-6"
          onClick={() => {
            if (!loading) onFilterChange(s);
          }}
        >
          <div className="w-5 h-9 flex items-center justify-center mt-1">
            <CheckBoxSqure onChange={() => {}} value={s?.isSelected} />
          </div>

          {s?.icon1 && <img src={s?.icon1} alt={s.msg} className="w-5" />}
          {s?.icon && (
            <s.icon color="var(--textBlack)" lineColor="var(--textBlack)" />
          )}
          <p>{s?.msg}</p>
        </div>
      ))}
    </div>
  );
};

export default FilterComponent;
